import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=0038f657"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=0038f657&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DialogContactDialog: require('/home/vsts/work/1/s/components/dialog/ContactDialog.vue').default,DialogChangePasswordDialog: require('/home/vsts/work/1/s/components/dialog/ChangePasswordDialog.vue').default})
